import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BannerComponent from "../components/vehiculos/banner.component";
import CategoriesComponent from "../components/vehiculos/categories.component";
import ContenidoComponent from "../components/vehiculos/contenido.component";
import { VehiclesAll } from "../components/conexion/vehicles.conexion";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";

/*eslint-disable */

const VehiculosPage: React.FC = () => {
  const [selectedCategories, setSelectedCategories] = useState("Todos");
  const [dataVehiculos, setDataVehiculos] = useState([]);
  const [visibleHeight, setVisibleHeight] = useState(0);
  useEffect(() => {
    // Accedemos directamente a la etiqueta body
    const bodyElement = document.body;

    // Añadir la clase deseada a body
    bodyElement.classList.remove("active"); //
    VehiclesAll().then(function (res: any) {
      let result: any = [];

      setDataVehiculos(res.data.data);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="vehiculo"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <div className="home-page-mascara"></div>
        <BannerComponent />
        <CategoriesComponent
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          categorias={dataVehiculos}
        />
        <ContenidoComponent
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          vehiculos={dataVehiculos}
        />
        <div style={{textAlign: "center", marginLeft: "5%", marginRight: "5%"}}>
          *Los valores y precios publicados son de referencia y pueden variar
          sin previo aviso.
        </div>
        <div style={{textAlign: "center", marginBottom: "40px", marginLeft: "5%", marginRight: "5%"}}>
          *Las imágenes son ilustrativas, algunas características de los
          vehículos de las imágenes pueden variar.
        </div>
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default VehiculosPage;
